import { Button } from "@/components/ui/button";
import { AlertTriangle, ShoppingCart } from "lucide-react";

export function ShortageWarning({ count, allOrdered, onOrderAll }) {
  return (
    <div className="flex items-center gap-2 text-[11px] text-red-600 bg-red-50 border border-red-100 rounded-md px-3 py-2" data-testid="shortage-warning">
      <AlertTriangle className="h-3.5 w-3.5 shrink-0" /> {count} material(s) short.
      {onOrderAll && (
        <Button size="sm" className="h-7 text-[11px] ml-auto bg-red-600 hover:bg-red-700" disabled={allOrdered} onClick={onOrderAll} data-testid="shortage-order-all">
          <ShoppingCart className="h-3 w-3 mr-1" />{allOrdered ? "All ordered ✓" : "Order All Missing (Grouped by Supplier)"}
        </Button>
      )}
    </div>
  );
}
